import { Gallery } from './components/Gallery'

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="gallery-header">
        <h1>Immerse Paris 2026</h1>
        <p>Official Event Photo Gallery</p>
      </header>
      <Gallery />
    </div>
  )
}

export default App
